<template>
  <LoadingSpinner v-if="loading" />

  <PostSigning
    v-else
    :branding="branding"
    v-bind="messaging"
  />
</template>

<script setup>
// @ts-check
import { computed } from 'vue'
import i18n from '@/locales'

import { useSignedData } from '@/composables/useSignedData'
import PostSigning from '@/components/screens/PostSigningScreen.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

const { status, branding, companyName, loading } = useSignedData()

const messaging = computed(() => {
  switch (status.value) {
    case 'cancelled':
      return {
        heading: i18n.t('envelopeSigned.cancelled'),
        message: i18n.t('envelopeSigned.cancelledMessage', { company: companyName.value }),
        type: 'error'
      }
    case 'rejected':
      return {
        heading: i18n.t('envelopeSigned.rejected'),
        message: i18n.t('envelopeSigned.rejectedMessage'),
        type: 'error'
      }
    case 'expired':
      return {
        heading: i18n.t('envelopeSigned.expired'),
        message: i18n.t('envelopeSigned.expiredMessage', { company: companyName.value }),
        type: 'error'
      }
    case 'signed':
      return {
        heading: i18n.t('envelopeSigned.finished'),
        message: i18n.t('envelopeSigned.finishedMessage'),
        type: 'success'
      }
    case 'sent':
      return {
        heading: i18n.t('envelopeSigned.awaiting'),
        messageIntro: i18n.t('envelopeSigned.awaitingMessageIntro'),
        message: i18n.t('envelopeSigned.awaitingMessage'),
        type: 'warning'
      }
    default:
      return {
        heading: i18n.t('error.somethingWentWrong'),
        message: i18n.t('error.unknownError'),
        type: 'error'
      }
  }
})
</script>
